export const LEGACY_RUN_WINDOW_WARNING_PREFIX =
  'Run window is less than 1 hour';

export function getFertWindowMinutes(
  runStartTime: string | null | undefined,
  runEndTime: string | null | undefined,
): number | null {
  if (!runStartTime || !runEndTime) return null;

  const start = new Date(runStartTime).getTime();
  const end = new Date(runEndTime).getTime();
  if (Number.isNaN(start) || Number.isNaN(end)) return null;

  return Math.max(0, Math.round((end - start) / 60000));
}

export function formatFertWindow(minutes: number | null): string {
  if (minutes === null) return '-';
  return `${(minutes / 60).toFixed(1)}h`;
}

export function isFertWindowTooShort(minutes: number | null): boolean {
  return minutes !== null && minutes < 60;
}

export function isReverseSortRun(
  semenTypes: string[] | null | undefined,
): boolean {
  if (!semenTypes || semenTypes.length === 0) return false;
  return semenTypes.every((type) => {
    const trimmed = type?.trim();
    return trimmed === 'RS F' || trimmed === 'RS M';
  });
}

export function buildFertWindowWarningMessage(
  warningMessage: string | null | undefined,
  fertWindowMinutes: number | null,
  tooShortMessage: string,
  suppressTooShort = false,
): string | undefined {
  const parts = (warningMessage ?? '')
    .split('|')
    .map((part) => part.trim())
    .filter(
      (part) =>
        part.length > 0 && !part.startsWith(LEGACY_RUN_WINDOW_WARNING_PREFIX),
    );

  if (!suppressTooShort && isFertWindowTooShort(fertWindowMinutes)) {
    parts.push(tooShortMessage);
  }

  return parts.length > 0 ? parts.join(' | ') : undefined;
}
